export const SentryOwnershipTeam = 'content-and-config-tool-web';
